var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#DFDDEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11H7C5.89543 11 5 11.8954 5 13V25C5 26.1046 5.89543 27 7 27H19C20.1046 27 21 26.1046 21 25V24H10C8.89543 24 8 23.1046 8 22V11Z",
    fill: "#B4B4C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPanel);
export default __webpack_public_path__ + "static/media/menu-panel.de67bd19483a7cc28cf83621d791ee4d.svg";
export { ForwardRef as ReactComponent };